/**
 * Paddle hands back pre-formatted price strings ("$249.00", "1.234,56 €").
 * Turn those back into a number so amounts can be multiplied and re-formatted.
 */
const parseAmount = (input) => {
  if (input === undefined || input === null) return NaN;

  const cleaned = String(input).replace(/[^0-9.,-]/g, '');
  if (!cleaned) return NaN;

  const lastSeparator = Math.max(cleaned.lastIndexOf('.'), cleaned.lastIndexOf(','));
  if (lastSeparator === -1) return parseFloat(cleaned);

  const decimals = cleaned.length - lastSeparator - 1;
  if (decimals !== 1 && decimals !== 2) {
    // Not a decimal separator, so it groups thousands.
    return parseFloat(cleaned.replace(/[.,]/g, ''));
  }

  const whole = cleaned.slice(0, lastSeparator).replace(/[.,]/g, '');
  return parseFloat(`${whole}.${cleaned.slice(lastSeparator + 1)}`);
};

const formatMoney = (value, currency) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return null;

  // Drop a whole-number's ".00"/",00" rather than stripping it as a string suffix
  // (which breaks for locales that format decimals differently) — just ask
  // Intl.NumberFormat for zero fraction digits when there's nothing after the point.
  const isWholeNumber = value % 1 === 0;

  if (!currency) return isWholeNumber ? value.toFixed(0) : value.toFixed(2);

  let formatted = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);

  if (formatted.startsWith('US$')) formatted = formatted.replace('US$', '$');

  return formatted;
};

export { parseAmount, formatMoney };
